import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { CheckboxGroup, Toggle } from "@gemini/ui";
import { useMapContext } from "../../../contexts/MapContext";
import { TRANSPORT_TYPES } from "../../../constants";
import { useI18n } from "@/shared/hooks";
export const mapTransportsPickerTestId = "cdp-location-map-transports-picker";
export const MapTransportsPicker = () => {
    const { t } = useI18n();
    const { layers, setLayers } = useMapContext();
    const handleToggleChange = (isSelected) => {
        setLayers(Object.assign(Object.assign({}, layers), { poi: isSelected }));
        if (!isSelected) {
            setLayers(Object.assign(Object.assign({}, layers), { pofi_subway_line: false, pofi_train_line: false, pofi_tram_line: false, poi: false }));
        }
    };
    const handleTransportChange = (selectedValues) => {
        const newLayers = Object.assign({}, layers);
        for (const { layerKey } of TRANSPORT_TYPES) {
            const isSelected = selectedValues.includes(layerKey);
            if (newLayers[layerKey] !== isSelected) {
                newLayers[layerKey] = isSelected;
            }
        }
        setLayers(newLayers);
    };
    const items = TRANSPORT_TYPES.map((transport) => ({
        label: t(`location.public_transports.${transport.label}`),
        value: transport.layerKey,
    }));
    const selectedValues = TRANSPORT_TYPES.filter((transport) => layers[transport.layerKey]).map((transport) => transport.layerKey);
    return (_jsxs(Box, { children: [_jsx(Toggle, { hasNecessityIndicator: false, isSelected: layers.poi, onChange: handleToggleChange, testId: `${mapTransportsPickerTestId}-toggle`, children: t("location.map.modal.transportation_lines.headline") }), layers.poi && (_jsx(Box, { display: "flex", flexDirection: "column", marginTop: "spacing.12", children: _jsx(CheckboxGroup, { testId: `${mapTransportsPickerTestId}-checkbox-group`, label: { content: "", isHidden: true }, items: items, value: selectedValues, onChange: handleTransportChange, name: "map-transport", hasBorder: true }) }))] }));
};
